import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaMapMarkerAlt, FaEnvelopeOpenText } from 'react-icons/fa';
import { FiArrowRight } from 'react-icons/fi';
import './CreativeContact.css';

const CreativeContact = () => {
  const cards = [
    {
      id: 1,
      icon: <FaWhatsapp />,
      title: "Instant Connect",
      desc: "Get real-time updates and quick itinerary changes directly on your WhatsApp. We're active 24/7 for you.",
      action: "CHAT ON WHATSAPP",
      link: "https://wa.me/919307604511",
      iconColor: "#25D366"
    },
    {
      id: 2,
      icon: <FaMapMarkerAlt />,
      title: "Regional Branch",
      desc: "Visit our office at Shakti Chambers, Sangamvadi, Pune 411003 for personalized trip planning.",
      action: "VIEW ON MAPS",
      link: "https://maps.google.com",
      iconColor: "#00a0e9"
    },
    {
      id: 3,
      icon: <FaEnvelopeOpenText />,
      title: "Official Inquiry",
      desc: "For corporate bookings and custom tour packages, drop us a detailed mail at chandramaholidays12@gmail.com.",
      action: "WRITE AN EMAIL",
      link: "mailto:chandramaholidays12@gmail.com",
      iconColor: "#ff6b6b"
    }
  ];

  return (
    <section className="contact-premium-section">
      <div className="container">
        
        {/* Screenshot Inspired Heading Structure */}
        <div className="heading-wrapper">
          <motion.span 
            className="sub-heading"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            GET IN TOUCH
          </motion.span>
          
          <motion.h2 
            className="main-display-title"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            We're Here To Help You <span>Nevigate</span>
          </motion.h2>
          
          {/* Animated Orange Line like Tour Packages Section */}
          <motion.div 
            className="heading-line"
            initial={{ width: 0 }}
            whileInView={{ width: "80px" }}
            transition={{ duration: 0.8, delay: 0.3 }}
          ></motion.div>
        </div>

        {/* 3-Card Layout */}
        <div className="contact-grid">
          {cards.map((card, index) => (
            <motion.div 
              key={card.id}
              className="info-card-box"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, type: "spring", stiffness: 100 }}
              whileHover={{ y: -12 }}
            >
              <div className="icon-top-circle" style={{ color: card.iconColor }}>
                {card.icon}
              </div>
              
              <h3 className="card-title-text">{card.title}</h3>
              <p className="card-info-para">{card.desc}</p>
              
              <div className="footer-flex">
                <a href={card.link} className="action-link">{card.action}</a>
                <motion.div className="circle-arrow-btn" whileHover={{ rotate: -45 }}>
                  <FiArrowRight />
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Recognition Footer */}
        {/* <div className="bottom-recognition">
          <p>OFFICIALLY RECOGNIZED BY</p>
          <div className="brand-logos">
            <span>H.P. TOURISM</span>
            <span className="divider"></span>
            <span>GOOGLE REVIEWS</span>
            <span className="divider"></span>
            <span>CHANDRAMA HOLIDAYS</span>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default CreativeContact;